export default {

    computed: {
        
        // Entity icon based on eventable_type
        getEventableIcon() {
            return (eventableType) => {
                switch(eventableType) {
                    case 'task': return 'mdi-clipboard-check-outline'
                    case 'trouble': return 'mdi-ticket-outline'
                    case 'helpdesktrouble': return 'mdi-ticket-outline'
                    case 'lead': return 'mdi-account-search-outline'
                    case 'prospect': return 'mdi-account-check'
                    case 'company': return 'mdi-domain'
                    case 'opportunity': return 'mdi-briefcase'
                    default: return 'mdi-calendar'
                }
            }
        },
        
        // format time
        formatEventDate(event) {
            return (event) => {
                if(event.allday) {
                    if(event.started_at === event.ended_at) {
                        return moment(event.started_at).format("dddd, D MMMM")
                    } else {
                        return moment(event.started_at).format("dddd, D MMMM") + ' - ' + moment(event.ended_at).format("dddd, D MMMM")
                    }
                } else {
                    return moment(event.started_at).format("dddd, D MMMM") + ' ⋅ ' + moment(event.started_at).format('h:mmA') + ' - ' + moment(event.ended_at).format('h:mmA')
                }
            }
        },

        formatCurrentMonth() {
            return (moment(this.today).format('MMMM')).charAt(0).toUpperCase() + (moment(this.today).format('MMMM')).slice(1)
        },

        formatTimeFromTo(event) {
            return (event) => {
                if(event.allday) {
                    return ''
                }
                let start_date_format = 'h:mmA'
                let end_date_format = 'h:mmA'
                if(moment(event.started_at).format('h:mm').endsWith(':00')) {
                    start_date_format = 'hA'
                }
                if(moment(event.ended_at).format('h:mm').endsWith(':00')) {
                    end_date_format = 'hA'
                }
                return moment(event.started_at).format(start_date_format) + ' – ' + moment(event.ended_at).format(end_date_format)
            }
        },		        

        // evantable
        eventableTitle() {
            if(this.eventParams && this.eventParams.eventable_type) {
                switch(this.eventParams.eventable_type) {
                case 'task':
                    return this.$trans('task')
                case 'trouble':
                    return this.$trans('trouble')
                case 'helpdesktrouble':
                    return this.$trans('helpdesktrouble')
                case 'lead':
                    return this.$trans('lead')
                case 'prospect':
                    return this.$trans('prospect')
                case 'company':
                    return this.$trans('company')
                case 'opportunity':
                    return this.$trans('opportunity')
                default:
                    return ''
                }
            }
            return ''
        },


        setEventTitle() {
            if(!_.isEmpty(this.eventable)) {
                switch(this.eventParams.eventable_type) {
                case 'task':
                    return this.eventable.task.title
                case 'trouble':
                    return this.eventable.trouble.title
                case 'helpdesktrouble':
                    const ticket = this.eventable.helpdesktrouble
                    return ticket.number ? `#${ticket.number} - ${ticket.title}` : ticket.title
                case 'lead':
                    return this.eventable.lead.business_name
                case 'prospect':
                    return this.eventable.prospect.business_name
                case 'company':
                    return this.eventable.company.business_name
                case 'opportunity':
                    return this.eventable.opportunity.name
                default:
                    return ''
                }
            } else {
                // Ritorna stringa vuota per usare il placeholder
                return ''
            }
        },
    },

    methods: {
        setColorMode() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
            localStorage.setItem('colorMode', this.$vuetify.theme.dark)
        },

        calcIntervalDate() {
            switch (this.type) {
                case 'month':
                    this.from = moment(this.today).startOf('month').subtract(6, 'd').format('YYYY-MM-DD HH:mm')
                    this.to = moment(this.today).endOf('month').add(6, 'd').format('YYYY-MM-DD HH:mm')
                    break
                case 'week':
                    this.from = moment(this.today).startOf('week').format('YYYY-MM-DD HH:mm')
                    this.to = moment(this.today).endOf('week').format('YYYY-MM-DD HH:mm')
                    break
                case 'work-week':
                    // Settimana lavorativa: da lunedì a venerdì
                    this.from = moment(this.today).startOf('week').format('YYYY-MM-DD HH:mm')
                    this.to = moment(this.today).startOf('week').add(4, 'days').endOf('day').format('YYYY-MM-DD HH:mm')
                    break
                case '4day':
                    this.from = moment(this.today).subtract(3, 'd').format('YYYY-MM-DD HH:mm')
                    this.to = moment(this.today).add(3, 'd').format('YYYY-MM-DD HH:mm')
                    break
                case 'day':
                    this.from = moment(this.today).format('YYYY-MM-DD 00:00')
                    this.to = moment(this.today).format('YYYY-MM-DD 23:59')
                    break
            }
        },	
        
        presetSelectedCalendars() {
            const savedCalendars = localStorage.getItem('selected_calendars')
            const allCalendars = this.calendars.concat(this.sharedCalendars)

            if(savedCalendars && savedCalendars != '[]' && savedCalendars != null) {
                // Se ci sono calendari salvati, usali
                const parsedCalendars = JSON.parse(savedCalendars)
                if(parsedCalendars.length == allCalendars.length) {
                    this.selectedCalendars = []
                    this.selectAll = true
                } else {
                    this.selectedCalendars = parsedCalendars
                }
            } else {
                // Se non ci sono calendari salvati o l'array è vuoto, seleziona tutti
                this.selectAll = true
                this.selectedCalendars = allCalendars.map(c => c.id)
            }
        },

        getEventTextColor(event) {
            if(this.type === 'month') {
                if(this.$vuetify.theme.dark) {
                    return 'color: white'
                } else {
                    return 'color: black'
                }
            } else {
                if(this.$eventBusUtility.lightOrDark(event.calendar.color) == 'light') {
                    return 'color: black'
                } else {
                    return 'color: white'
                }
            }
        },	        

        getEventRoute(event) {
            // Se non c'è eventable_type, rimanda al calendario
            if (!event.eventable_type || !event.eventable_id) {
                return '/calendar'
            }

            // Calcola la route in base al tipo di evento
            switch(event.eventable_type) {
                case 'opportunity':
                    return `/opportunities/${event.eventable_id}`
                case 'task':
                    return `/tasks/${event.eventable_id}`
                case 'trouble':
                    return `/tickets/troubles/${event.eventable_id}`
                case 'helpdesktrouble':
                    return `/helpdesktroubles/${event.eventable_id}`
                case 'project':
                    return `/projects/${event.eventable_id}`
                case 'lead':
                    return `/leads/${event.eventable_id}`
                case 'prospect':
                    return `/prospects/${event.eventable_id}`
                case 'company':
                    return `/companies/${event.eventable_id}`
                default:
                    return '/calendar'
            }
        },
    },



}